// The general-purpose bottom sheet (dialog #gsheet): new group, invite, share, profile, season picker...
import { $, el } from "./dom.ts";
import { t } from "./i18n.ts";

export const sheet = $<HTMLDialogElement>("#gsheet");

/** Fills the sheet with a title, body and footer buttons, and opens it. */
export function openSheet(title: string, body: (Node | null)[], foot: Node[]): void {
  $("#gsheet-title").textContent = title;
  $("#gsheet-body").replaceChildren(...body.filter((n): n is Node => n != null));
  $("#gsheet-foot").replaceChildren(...foot);
  if (!sheet.open) sheet.showModal();
}
export const closeSheet = (): void => sheet.close();
$("#gsheet-close").addEventListener("click", closeSheet);

/** Footer helpers: a spacer, a Cancel button, and a primary button. */
export const grow = (): HTMLElement => el("span", { class: "grow" });
export const cancelButton = (): HTMLButtonElement => el("button", { class: "btn", type: "button", onclick: closeSheet }, t("cancel"));
export const primaryButton = (label: string, onclick: (btn: HTMLButtonElement) => unknown): HTMLButtonElement =>
  el("button", { class: "btn primary", type: "button", onclick: (e) => onclick(e.currentTarget) }, label);
